import { render, staticRenderFns } from "./ContactService.vue?vue&type=template&id=b2d58ef8&scoped=true"
import script from "./ContactService.vue?vue&type=script&lang=js"
export * from "./ContactService.vue?vue&type=script&lang=js"
import style0 from "./ContactService.vue?vue&type=style&index=0&id=b2d58ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d58ef8",
  null
  
)

export default component.exports